export interface Pax {
  id: string;
  name: string;
  surname: string;
  age: number;
  dob: string;
  email: string;
}

export enum BookStatusType {
  OK = 'OK',
  ON_REQUEST = 'ON_REQUEST',
  CANCELLED = 'CANCELLED',
  UNKNOWN = 'UNKNOWN',
  PENDING = 'PENDING',
}
